// extracted by mini-css-extract-plugin
var _1 = "CouponCodeInput-module__error--g9hNb";
var _2 = "CouponCodeInput-module__formContainer--z0Q_W";
var _3 = "CouponCodeInput-module__input--DuFAo";
var _4 = "CouponCodeInput-module__loadingWrapper--MUVcM";
export { _1 as "error", _2 as "formContainer", _3 as "input", _4 as "loadingWrapper" }
